const list = {
  path: 'marketingList',
  component: resolve => require(['@/pages/admin/marketing/marketingList'], resolve)
}

export default list
